
import { mapState, mapGetters } from "vuex";
import { KOT_REPRINT } from "@/constants/MixpanelEvents.js";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  props: {
    dialog: false
  },
  components: { ResponsiveDialog },
  created() {
    this.$nuxt.$on("print-completed", () => {
      this.loading = false;
      this.$emit("close-dialog");
    });
  },
  data() {
    return {
      loading: false,
      validPrinters: [],
      selectedPrinters: [],
      consolidatePrint: false
    };
  },
  computed: {
    ...mapState("reciever", ["orderDetails"]),
    ...mapState("restaurant", ["printers"]),
    ...mapGetters("restaurant", ["getRecieverSettings"]),
    consolidatedPrintEnabled() {
      return !!this.getRecieverSettings(this.orderDetails.restaurant_id)
        .enable_consolidated_kot_printer;
    }
  },
  watch: {
    // printers(val) {},
  },
  mounted() {
    if (this.isAndroid()) {
      this.handleKotPrint();
    } else {
      this.validPrinters = this.printers.filter((printer) => {
        return this.orderDetails.items.find((item) => {
          return (
            !item.kot_disabled &&
            item.printer_id &&
            item.printer_id == printer.id
          );
        });
      });
      this.selectedPrinters = this.validPrinters;
    }
    this.consolidatePrint = this.consolidatedPrintEnabled;
  },
  methods: {
    async handleKotPrint() {
      this.loading = true;
      if (this.selectedPrinters?.length || this.isAndroid()) {
        this.$nuxt.$emit(
          "initiate-print",
          this.orderDetails,
          "kot",
          false,
          true,
          false,
          false,
          true,
          this.selectedPrinters,
          "order-reprint"
        );
      }
      if (this.consolidatePrint) {
        this.$nuxt.$emit(
          "initiate-print",
          this.orderDetails,
          "master-kot",
          false,
          true,
          false,
          false,
          true,
          this.printers,
          "order-reprint"
        );
      }
      await this.sleep(1000);
      this.mixPanelTrackEvent(KOT_REPRINT);
      this.$emit("close-dialog");
    },
    printerSelectionChange(printer) {
      const index = this.selectedPrinters.findIndex(
        (el) => el.id == printer.id
      );
      if (index >= 0) {
        this.selectedPrinters.splice(index, 1);
      } else {
        this.selectedPrinters.push(printer);
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("print-completed");
  }
};
